import { ArrowDown, Loader2, Lock, Send } from "lucide-react";

const btn = "inline-flex h-12 items-center gap-2 rounded-full px-6 font-semibold shadow-festive transition-[transform,background-color,opacity] duration-200 active:scale-95";

export const SubmitBar = ({ count, total, exhausted, isChange, changed, submitting, onSubmit, onStart }) => (
  <div className="fixed inset-x-0 bottom-0 z-40 border-t border-gold/40 bg-ivory/95 px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur-md">
    <div className="mx-auto flex max-w-2xl items-center gap-3">
      <div className="min-w-0 flex-1">
        <p data-testid="picks-count" className="font-display text-lg font-bold leading-none text-maroon">
          {exhausted ? "Final vote recorded" : `${count} pick${count === 1 ? "" : "s"}`}
        </p>
        <p className="mt-1 text-xs text-ink-muted">
          {exhausted ? "You have used all your vote changes" : isChange && !changed ? "This is your current vote" : `${total} categories · skip any`}
        </p>
      </div>
      {exhausted ? (
        <button type="button" disabled data-testid="review-votes-btn" className={`${btn} bg-forest text-white opacity-40`}>
          <Lock className="h-4 w-4" /> No changes left
        </button>
      ) : !count ? (
        <button type="button" data-testid="bar-start-voting-btn" onClick={onStart} className={`${btn} bg-gold text-maroon-deep hover:bg-gold-light`}>
          Start voting <ArrowDown className="h-4 w-4" />
        </button>
      ) : (
        <button type="button" data-testid="review-votes-btn" disabled={submitting || !changed} onClick={onSubmit} className={`${btn} bg-forest text-white hover:bg-forest-light disabled:opacity-40`}>
          {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
          {isChange ? "Review my change" : "Review & Submit"}
        </button>
      )}
    </div>
  </div>
);
